import * as ko from "knockout";
import {IMessage, TRouteId} from "../../index";
import {VariableAbstract} from "./VariableAbstract";
import {TServiceName} from "../../constants/ApiServices";
import {getRouteLabel} from "../../constants/RouteDefinitions";

export {template} from "./VariableAbstract";

export class viewModel extends VariableAbstract<IMessage> {
    protected routeId: TRouteId = 'messageflowdetails';
    protected serviceName: TServiceName = 'getmessage'

    protected override getTitle(): string {
        const item = ko.unwrap(this.item)
        let ret = `((${getRouteLabel(this.routeId)}|uc))

((id)):
${item.id}

((name)):
${item.name}

((active)):
`

        if (item.active) {
            ret += `((yes))`
        } else {
            ret += `((no))`
        }

        const subject = item.subject;
        if (subject) {
            ret += `

((subject)):
${subject}`
        }

        const description = item.description;
        if (description) {
            ret += `

((description)):
${description}`
        }

        const rulesetname = item.rulesetname
        if (rulesetname) {
            ret += `
            
((ruleset)):
${rulesetname}`
        }

        const recipientfield = item.recipientfield
        if (recipientfield) {
            ret += `
            
((recipientfield)):
${recipientfield}`
        }

        const addrecipient = item.addrecipient
        if (addrecipient) {
            ret += `
            
((recipient|p|p)):
${addrecipient.split(',').map(o => '• ' + o).join('\n')}`
        }

        return ret
    }
}
